import React from 'react';

const LoadingSpinner = () => (
  <div className="flex pt-8 justify-center items-center">
    <div className="loading-spinner"></div>
  </div>
);

export default LoadingSpinner;
